import appConfig from "../appconfig";
import MarketingCard from "../helper/MarketingCardHelper";
import {isProductCatalogDataAvailable} from "../store/ProductCatalogNonReactiveStorage";

export default {
	methods: {
		goTo(path, productIds = []) {
			const self = this;
			if(this.showUpsellModal(this, productIds)) {
				return;
			}
			if (self.isExternalLink(path)) {
				return;
			}
			const params = new URLSearchParams(path.includes("?") ? path.split("?")[1] : path);
			const productId = params.get("productId");
			const action = params.get("action");
			const {productCatalog} = self.$store.getters;
			if(self.$store.getters.featureToggles.enableFrontpageMarketingCards && ["kiosk"].includes(appConfig.channelAlias())) {
				let link = path;
				self.updateLocalStorage(productId, action);
				if (productId && isProductCatalogDataAvailable()) {
					const categoryId = self.getCategory(productId, productCatalog).extId;
					link = link.replace(/shop-selection/,`category/${categoryId}`);
				}
				self.$router.push(link);
			}
			if(["kiosk", "desktopBrowser"].includes(appConfig.channelAlias())) {
				if (productId && productCatalog) {
					const category = self.getCategory(productId, productCatalog);
					MarketingCard.setState(self, {category, productId});
					self.updateLocalStorage(productId, action);
					return;
				}
			} else {
				const {productCatalog} = self.$store.getters;
				let link = path;
				self.updateLocalStorage(productId, action);
				if (productId && isProductCatalogDataAvailable()) {
					const categoryId = self.getCategory(productId, productCatalog).extId;
					link = link.replace(/shop-selection/,`category/${categoryId}`);
				}
				self.$router.push(link);
			}
		},
		isExternalLink(path) {
			const currentUrl = appConfig.mobile.isMobileApp() ? appConfig.getBaseUrl() : location.origin;
			const route = path.startsWith(currentUrl) ? path.replace(currentUrl, "") : path;
			if (/^http(s)?:\/\//gi.test(route) || route.startsWith("/api")) {
				window.open(path, "_blank");
				return true;
			}
		},
		updateLocalStorage(productId, action) {
			localStorage.setItem("action", action);
			localStorage.setItem("scrollToProductIds", productId);
		},
		getCategory(productId, productCatalog) {
			return productCatalog.getAllCategoriesOfProduct(productId)[0];
		},
		showUpsellModal(self, productIds) {
			// disable upsell modal in the context of the product configuring
			if(self.$route.path.includes("/configuration")) {
				return false;
			}
			if(
				self.$store.getters.rcmMarketingCard.enable
				&& self.$store.getters.rcmMarketingCard.productIds.length
				&& self.$store.getters.featureToggles.enableShowingUpsellModalWithMarketingCards
			) {
				const filteredItems = self.$store.getters.rcmMarketingCard.productIds
					.filter(item => productIds.includes(item) && self.getProduct(item));
				const cartItemsArr = self.$store.getters.cartProducts.map(cp => cp.productId);
				if(filteredItems.every(item => cartItemsArr.includes(item))) {
					return false;
				}
				// modal should be shown only if multiple items are returned
				// otherwise proceed with scrolling to the product
				if(filteredItems.length > 1) {
					self.recommendedProductsMap = {};
					filteredItems.forEach(item => self.recommendedProductsMap[item] = null);
					self.displayUpsellModal = true;
					return true;
				}
			}
			return false;
		}
	}
};
